<!-- <template>
	<h1>关于我们</h1>
	<iframe src="https://www.ninesleeves.online/guanyuwomen/index.htm" style="width: 1680px;height: 860px;"></iframe>
	<table>
		<ul>
	<li v-for="item in data":key="item.id">{{ item.title }}</li>
	</ul>
	</table>
</template> -->

<template>
<div>
	<h1>axios使用toRef请求数据案例</h1>
	<el-button @click="ccb">发起请求</el-button>
	<ul>
		<el-button v-for="item in data" :key="item.id">{{ item.文章标题 }}</el-button>
		<el-tabs type="border-card">
		<el-tab-pane label="这个label标签他在eltabpane中不接受item所以标题没法子" v-for="item in data" :key="item.id">{{ item.练不下去了随便吧 }}</el-tab-pane>
		</el-tabs>
<!-- :id="forld(3)"由于json文本中暂时没有id属性所以暂不可用，然后那个json是拼接的urlcode所以没有用“”要绑id -->
<!-- 待全改json以后再改吧如果本项目上传了你们自己改下 -->
		<!-- <a href="" v-for="item in data" :key="item.id">{{ item.title }}</a> -->
		<!-- <code v-for="item in data" :key="item.id">{{ item.练不下去了随便吧 }}</code> -->
		</ul>
		</div>
		<el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="isCollapse">
		  <el-submenu index="1">
		    <template slot="title">
		      <i class="el-icon-location"></i>
		      <span slot="title">新闻中心</span>
		    </template>
		    <el-menu-item-group>
		     
		      <el-menu-item index="1-1">选项1</el-menu-item>
		      <el-menu-item index="1-2">选项2</el-menu-item>
		    </el-menu-item-group>
		
		      <el-menu-item index="1-3">选项3</el-menu-item>
		
		      <el-menu-item index="1-4-1">选项4</el-menu-item>
		 
		  </el-submenu>
		  <el-menu-item index="2">
		    <i class="el-icon-menu"></i>
		    <span slot="title">娱乐视频</span>
		  </el-menu-item>
		  <el-menu-item index="3" >
		    <i class="el-icon-document"></i>
		    <span slot="title">在线购物</span>
		  </el-menu-item>
		  <el-menu-item index="4">
		    <i class="el-icon-setting"></i>
		    <span slot="title">企业文化</span>
		  </el-menu-item>
		</el-menu>
</template>
<style>

	html{
	border-radius: 30px;
	}
	  .el-carousel__item h3 {
	    color: #475669;
	    font-size: 18px;
	    opacity: 0.75;
	    line-height: 300px;
	    margin: 0;
	  }
	  
	  .el-carousel__item:nth-child(2n) {
	    background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	    background-color: #d3dce6;
	  }
	
	
	  .el-menu-vertical-demo:not(.el-menu--collapse) {
	    width: 200px;
	    min-height: 400px;
	  }
	
</style>
<script>
	import axios from 'axios';
	import { reactive,toRefs } from 'vue';
	export default {
		setup() {
			const state = reactive({
				data: [],
			});
			const ccb = async () => {
				const response = await axios.get('https://www.fack.ninesleeves.online/liningbo');
				console.warn(response.data)
				state.data = response.data
			};
			return {
				ccb,
				...toRefs(state)
				};
		},
	};
</script>
